__webpack_require__.p = "https://unpkg.com/jupyter-vuetify@3.0.0/dist/";